import { useMyMutation, MutationInfos } from '../helpers';
import {
    CreateSelfServiceContractInput,
    UpdateSelfServiceContractInput,
    SignSelfServiceContractInput,
    LogStepSelfServiceInput,
} from '../../apiTypes';
import { typeSelfService } from './types';

function logStepSelfService(variables: LogStepSelfServiceInput): MutationInfos {
    return {
        method: 'post',
        path: `/self-service/log-step`,
        type: typeSelfService.LOG_STEP_SELFSERVICE,
        params: {
            ...variables,
        },
    };
}

function createSelfServiceContract(variables: CreateSelfServiceContractInput): MutationInfos {
    return {
        method: 'post',
        path: `/self-service/contracts`,
        type: typeSelfService.CREATE_SELFSERVICE_CONTRACT,
        params: {
            ...variables,
        },
    };
}

function updateSelfServiceContract(variables: UpdateSelfServiceContractInput): MutationInfos {
    const { contractId } = variables;
    return {
        method: 'put',
        path: `/self-service/contracts/${contractId}`,
        type: typeSelfService.UPDATE_SELFSERVICE_CONTRACT,
        params: {
            ...variables,
        },
    };
}

function signSelfServiceContract(variables: SignSelfServiceContractInput): MutationInfos {
    const { contractId } = variables;
    return {
        method: 'put',
        path: `/self-service/contracts/${contractId}/sign`,
        type: typeSelfService.SIGN_SELFSERVICE_CONTRACT,
        params: {
            ...variables,
        },
    };
}

export function useLogStepSelfService() {
    return useMyMutation(logStepSelfService, {
        onSuccess: () => {},
    });
}
export function useCreateSelfServiceContract() {
    return useMyMutation(createSelfServiceContract, {
        onSuccess: () => {},
        retry: 0,
    });
}

export function useUpdateSelfServiceContract() {
    return useMyMutation(updateSelfServiceContract, {
        onSuccess: () => {},
        retry: 0,
    });
}

export function useSignSelfServiceContract() {
    return useMyMutation(signSelfServiceContract, {
        onSuccess: () => {},
        retry: 0,
    });
}
